<template>
  <a-table
    :columns="columns"
    :row-key="(record) => record._id"
    :data-source="data"
    :pagination="pagination"
    :loading="loading"
    @change="handleTableChange"
    bordered
    size="small"
  >
    <template slot="name" slot-scope="name">
      <a-tag color="blue" @click="copy(name)" style="cursor:pointer;">
        {{ name }}
      </a-tag>
    </template>
    <template slot="bool" slot-scope="bool">
      <a-icon v-if="bool" type="check-circle" class="text-success" />
      <a-icon v-if="!bool" type="close-circle" class="text-danger" />
    </template>
    <template slot="date" slot-scope="date">
      <a-tag color="orange">
        {{ momentom(date) }}
      </a-tag>
    </template>
    <template slot="title" slot-scope="">
      <a-space>
        <a-input-search
          placeholder="search permissions by name, description"
          style="width: 500px"
          enter-button
          size="small"
          @search="onSearch"
        />

        <a-button
          @click="() => fetch()"
          type="dark"
          shape="round"
          icon="reload"
          size="small"
          >reload</a-button
        >

        <a-button
          @click="emitGeneratePermissions"
          type="primary"
          shape="round"
          icon="add"
          size="small"
          >auto generate permissions</a-button
        >
      </a-space>
    </template>
  </a-table>
</template>

<script>
import moment from "moment";
import { copyTextToClipboard } from "../../utils/common";
export default {
  data() {
    return {
      columns: [
        {
          title: "permission name",
          dataIndex: "name",
          sorter: true,
          width: "20%",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "description",
          dataIndex: "description",
        },
        {
          title: "createdAt",
          dataIndex: "createdAt",
          sorter: true,
          scopedSlots: { customRender: "date" },
          width: "10%",
        },
        {
          title: "active",
          dataIndex: "active",
          sorter: true,
          scopedSlots: { customRender: "bool" },
          width: "10%",
        },
      ],
      pagination: {},
      data: [],
      loading: null,
    };
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;

      const params = {
        pageSize: pagination.pageSize,
        page: pagination.current,
        searchFields: [],
        ...filters,
      };

      if (sorter.order) {
        params.sort =
          sorter.order === "ascend" ? sorter.field : `-${sorter.field}`;
      }
      this.fetch(params);
    },
    fetch(params = {}) {
      this.loading = true;
      this.axios
        .get("/api/permissions", {
          params: {
            //results: 10,
            ...params,
          },
        })
        .then(({ data }) => {
          const pagination = { ...this.pagination };
          // Read total count from server
          pagination.total = data.total;
          // pagination.total = 200;
          this.loading = false;

          this.data = data.rows;
          this.pagination = pagination;
        });
    },
    momentom(input) {
      let date = moment(input);
      return date.fromNow();
    },
    copy(text) {
      copyTextToClipboard(text);
      this.$message.info("copied !");
    },
    onSearch(t, e) {
      if (t) {
        this.fetch({
          searchFields: ["name", "description"],
          search: t,
        });
      } else {
        this.fetch({});
      }
    },
    emitGeneratePermissions() {
      this.axios
        .post("/api/permissions/genenerate/all", {})
        .then(({ data }) => {
          this.$message.success(
            "generation event sucessfuly send to al services. list automatic refreshed after 5 seconds"
          );
          setTimeout(() => {
            this.fetch();
          }, 5000);
        })
        .catch((err) => {});
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
